var render = function render(){var _vm=this,_c=_vm._self._c;return _c('show-missing-stock-table',{attrs:{"context":"missingStock"}})
}
var staticRenderFns = []

export { render, staticRenderFns }